import { render, staticRenderFns } from "./addXmlRecord.vue?vue&type=template&id=92af6ede&scoped=true&"
import script from "./addXmlRecord.vue?vue&type=script&lang=js&"
export * from "./addXmlRecord.vue?vue&type=script&lang=js&"
import style0 from "./addXmlRecord.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addXmlRecord.vue?vue&type=style&index=1&id=92af6ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92af6ede",
  null
  
)

export default component.exports